import { normalize, schema } from 'normalizr';
import { IPictureEntries, IPicturesEntries } from '../../../pictures/types';
import { pictureSchema } from '../../models/picture';
import {
  IApiMultiplePictureResponse,
  IApiPictureResponse,
} from '../../models/picture/picture.types';

const picturesSchema = new schema.Object({
  data: [pictureSchema],
});

export const picturesNormalizer = (
  pictures: IApiMultiplePictureResponse
): IPicturesEntries => normalize(pictures, picturesSchema);

const pictureResponseSchema = new schema.Object({
  data: pictureSchema,
});

export const pictureNormalizer = (
  picture: IApiPictureResponse
): IPictureEntries => normalize(picture, pictureResponseSchema);
